import Pricing from '../../Sections/Pricing/Pricing'
import TemplateLibrary from '../../Sections/TemplateLibrary/TemplateLibrary'
import GetEfficiency from '../../Sections/GetEfficiency/GetEfficiency'

const PricingPage = () => {
  return [ <Pricing key="1" />, <TemplateLibrary key="tl" /> ,<GetEfficiency key="gef"/>]
}

export default PricingPage
